if (!customElements.get('monogram-modal')) {
  class MonogramModal extends HTMLElement {
    constructor() {
      super();
      this.activeMenuElementIndex = -1;
      this.activeMenuSubComponentIndex = -1;
      this.activeStep = -1;
      this.wip = false;
      this.monogramModalContainer = this.querySelector('.js-monogram-container');
      this.triggerButton = this.querySelector('.js-show-monogram-modal');
      this.monogramModal = this.querySelector('.js-monogram-modal');
      this.closeModalButtons = this.querySelectorAll('.js-close-monogram-modal');
      this.mainContainer = document.querySelector('main');
      this.footerContainer = document.querySelector('#shopify-section-footer');
      this.footerSection1 = document.querySelector('#shopify-section-nine15--ctas--footer-1');
      this.footerSection2 = document.querySelector('#shopify-section-nine15--ctas--footer-2');
      this.productContainer = this.closest('.product');
      this.initEventListeners();
    }
    initEventListeners() {
      let _this = this;
      _this.widgetLoaded = false;
      document.addEventListener('loaded.jtbc.silhouette', () => {
        _this.widgetLoaded = true;
        _this.widgetWrapper = _this.querySelector('.jtbc-wrapper');
        _this.widgetPreviewPanel = _this.querySelector('.jtbc-preview-panel');
        _this.addToCartActions = _this.querySelector('.jtbc-menu-panel > .jtbc-actions');
        _this.widgetMenuPanel = _this.querySelector('.jtbc-menu-panel');
        _this.desktopTitle = _this.querySelector('.jtbc-info-wrapper__desktop .jtbc-product-title');
        _this.mobileTitle = _this.querySelector('.js-jtbc-product-title');
        _this.widgetActions = _this.querySelector('.jtbc-wrapper > .jtbc-actions');
        if (_this.widgetWrapper && _this.widgetPreviewPanel && _this.widgetMenuPanel && _this.widgetActions) {
          _this.widgetDataPanel = document.createElement('div');
          _this.widgetDataPanel.classList.add('jtbc-data-panel');
          _this.widgetMenuPanel.remove();
          _this.widgetActions.remove();
          _this.widgetDataPanel.appendChild(_this.widgetMenuPanel);
          _this.widgetDataPanel.appendChild(_this.widgetActions);
          _this.widgetWrapper.appendChild(_this.widgetDataPanel);

          let productTitle = document.querySelector('.js-product-title') ? document.querySelector('.js-product-title').dataset.productTitle : '';
          if (_this.mobileTitle) {
            _this.mobileTitle.innerText = productTitle;
          }
          if (_this.desktopTitle) {
            _this.desktopTitle.innerText = productTitle;
          }

          let menuContainer = _this.widgetMenuPanel.querySelector('.jtbc-menu-container');
          _this.widgetProgressBar = document.createElement('div');
          _this.widgetProgressBar.classList.add('jtbc-progress-bar');
          menuContainer.parentNode.insertBefore(_this.widgetProgressBar, menuContainer);
          _this.stepButton = document.createElement('div');
          _this.stepButton.classList.add('jtbc-step-button');
          _this.stepButton.innerHTML = `<button class="jtbc-step-button-item js-next-step-button" disabled>Select</button>`;
          menuContainer.parentNode.append(_this.stepButton);
          _this.backButton = document.createElement('div');
          _this.backButton.classList.add('jtbc-back-button');
          _this.backButton.innerHTML = `<button class="jtbc-back-button-item js-back-step-button"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
            <path d="M0.108539 8L0.50056 8.39202L7.71652 15.608L8.10854 16L8.89258 15.216L8.50056 14.8239L1.67662 8L8.50056 1.17606L8.89258 0.784042L8.10854 1.02815e-07L7.71652 0.392021L0.50056 7.60798L0.108539 8Z" fill="#212121"/>
            </svg></button>
          `;
          menuContainer.parentNode.insertBefore(_this.backButton, menuContainer);
          _this.initStepButtonEventListener();
          _this.initBackButtonEventListener();
          _this.initResizeEventListener();
        }
        _this.bindObserver();
      });
      _this.triggerButton && _this.triggerButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (!_this.widgetLoaded) return;
        //Check if we need to reset
        if (this.activeStep > 0) {
            const monogramModalScript = document.querySelector('#monogram-script');
            if(monogramModalScript?.dataset?.variantId && _this.dataset.variantId !== monogramModalScript?.dataset?.variantId) {
                this.activeMenuElementIndex = -1;
                this.activeMenuSubComponentIndex = -1;
                this.activeStep = -1;
                _this.dataset.variantId = monogramModalScript?.dataset?.variantId;
            }
        }
        _this.updateWidgetData();
        _this.initWidgetData();
        _this.updateStepButton();
        _this.updateProgressBar();
        _this.monogramModal.classList.add('is-visible');
        _this.productContainer.classList.add('show-monogram');
        _this.mainContainer.querySelectorAll('.shopify-section:not(.shopify-section-product)').forEach(section => {
          section.classList.add('hide');
        });
        if (_this.footerContainer) {
          _this.footerContainer.classList.add('hide');
        }
        if (_this.footerSection1) {
          _this.footerSection1.classList.add('hide');
        }
        if (_this.footerSection2) {
          _this.footerSection2.classList.add('hide');
        }
        _this.resizeContainer();
        _this.scrollToBlock();
      });
      _this.closeModalButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          _this.monogramModal.classList.remove('is-visible');
          _this.productContainer.classList.remove('show-monogram');
          _this.mainContainer.querySelectorAll('.shopify-section:not(.shopify-section-product)').forEach(section => {
            section.classList.remove('hide');
          });
          if (_this.footerContainer) {
            _this.footerContainer.classList.remove('hide');
          }
          if (_this.footerSection1) {
            _this.footerSection1.classList.remove('hide');
          }
          if (_this.footerSection2) {
            _this.footerSection2.classList.remove('hide');
          }
        });
      });
    }
    initResizeEventListener() {
      let _this = this;
      window.addEventListener('resize', () => {
        _this.resizeContainer();
      });
    }
    resizeContainer() {
      let _this = this;
      if (_this.productContainer.classList.contains('show-monogram')) {
        _this.productContainer.style.setProperty('--product-container-height', _this.monogramModal.offsetHeight + 'px');
      }
    }
    initStepButtonEventListener() {
      this.stepButton && this.stepButton.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault();
        this.wip = true;
        if (this.stepButton.querySelector('button').disabled){
          this.wip = false;
          return;
        };
        if (this.activeStep < this.totalSteps - 1) {
          this.activeStep++;
          if (this.activeMenuElementItem.slug === 'm1_embroidery' || this.activeMenuElementItem.slug === 'm2_embroidery' || this.activeMenuElementItem.slug === 'm3_embroidery') {
            if (this.activeMenuSubComponentIndex < this.activeMenuElementItem.sub_components.length - 1) {
              this.activeMenuSubComponentItem.style.display = 'none';
              this.activeMenuSubComponentIndex++;
              this.activeMenuSubComponentItem = this.activeMenuElementItem.sub_components[this.activeMenuSubComponentIndex];
              this.activeMenuSubComponentItem.style.display = 'flex';
            } else {
              jtbCustomizer.elements[this.activeMenuElementItem.slug].hide();
              this.activeMenuElementIndex++;
              this.activeMenuSubComponentIndex = -1;
              if (this.activeMenuElementIndex >= this.widgetMenuElementsData.length) {
                this.activeMenuElementIndex = this.widgetMenuElementsData.length - 1;
                this.activeStep = this.totalSteps - 1;
              }
              this.activeMenuElementItem = this.widgetMenuElementsData[this.activeMenuElementIndex];
              jtbCustomizer.elements[this.activeMenuElementItem.slug].show();
              if (this.activeMenuElementItem.slug === 'm1_embroidery' || this.activeMenuElementItem.slug === 'm2_embroidery' || this.activeMenuElementItem.slug === 'm3_embroidery') {
                this.activeMenuSubComponentIndex = 0;
                this.activeMenuSubComponentItem = this.activeMenuElementItem.sub_components[this.activeMenuSubComponentIndex];
                this.activeMenuSubComponentItem.style.display = 'flex';
                this.activeMenuElementItem.element.querySelectorAll('.jtbc-embroidery-step').forEach((stepEl, stepIndex) => {
                  if (stepIndex !== 0) {
                    stepEl.style.display = 'none';
                  }
                });
              }
            }
          } else {
            jtbCustomizer.elements[this.activeMenuElementItem.slug].hide();
            this.activeMenuElementIndex++;
            if (this.activeMenuElementIndex >= this.widgetMenuElementsData.length) {
              this.activeMenuElementIndex = this.widgetMenuElementsData.length - 1;
              this.activeStep = this.totalSteps - 1;
            }
            this.activeMenuElementItem = this.widgetMenuElementsData[this.activeMenuElementIndex];
            jtbCustomizer.elements[this.activeMenuElementItem.slug].show();
            if (this.activeMenuElementItem.slug === 'm1_embroidery' || this.activeMenuElementItem.slug === 'm2_embroidery' || this.activeMenuElementItem.slug === 'm3_embroidery') {
              this.activeMenuSubComponentIndex = 0;
              this.activeMenuSubComponentItem = this.activeMenuElementItem.sub_components[this.activeMenuSubComponentIndex];
              this.activeMenuSubComponentItem.style.display = 'flex';
              this.activeMenuElementItem.element.querySelectorAll('.jtbc-embroidery-step').forEach((stepEl, stepIndex) => {
                if (stepIndex !== 0) {
                  stepEl.style.display = 'none';
                }
              });
            }
          }
        }
        this.wip = false;
        this.updateWidgetData();
        this.initWidgetData();
        this.updateStepButton();
        this.updateProgressBar();
        this.resizeContainer();
        this.scrollToBlock();
      });
    }
    initBackButtonEventListener() {
      this.backButton && this.backButton.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault();
        this.wip = true;
        if (this.activeStep > 0) {
          this.activeStep--;
          if (this.activeMenuElementItem.slug === 'm1_embroidery' || this.activeMenuElementItem.slug === 'm2_embroidery' || this.activeMenuElementItem.slug === 'm3_embroidery') {
            if (this.activeMenuSubComponentIndex > 0) {
              this.activeMenuSubComponentItem.style.display = 'none';
              this.activeMenuSubComponentIndex--;
              this.activeMenuSubComponentItem = this.activeMenuElementItem.sub_components[this.activeMenuSubComponentIndex];
              this.activeMenuSubComponentItem.style.display = 'flex';
            } else {
              jtbCustomizer.elements[this.activeMenuElementItem.slug].hide();
              this.activeMenuElementIndex--;
              if (this.activeMenuElementIndex < 0) {
                this.activeMenuElementIndex = 0;
                this.activeStep = 0;
              }
              this.activeMenuElementItem = this.widgetMenuElementsData[this.activeMenuElementIndex];
              jtbCustomizer.elements[this.activeMenuElementItem.slug].show();
              if (this.activeMenuElementItem.slug === 'm1_embroidery' || this.activeMenuElementItem.slug === 'm2_embroidery' || this.activeMenuElementItem.slug === 'm3_embroidery') {
                this.activeMenuSubComponentIndex = this.activeMenuElementItem.sub_components.length - 1;
                this.activeMenuSubComponentItem = this.activeMenuElementItem.sub_components[this.activeMenuSubComponentIndex];
                this.activeMenuSubComponentItem.style.display = 'flex';
                this.activeMenuElementItem.element.querySelectorAll('.jtbc-embroidery-step').forEach((stepEl, stepIndex) => {
                  if (stepIndex !== this.activeMenuSubComponentIndex) {
                    stepEl.style.display = 'none';
                  }
                });
              }
            }
          } else {
            jtbCustomizer.elements[this.activeMenuElementItem.slug].hide();
            this.activeMenuElementIndex--;
            if (this.activeMenuElementIndex < 0) {
              this.activeMenuElementIndex = 0;
              this.activeStep = 0;
            }
            this.activeMenuElementItem = this.widgetMenuElementsData[this.activeMenuElementIndex];
            jtbCustomizer.elements[this.activeMenuElementItem.slug].show();
            if (this.activeMenuElementItem.slug === 'm1_embroidery' || this.activeMenuElementItem.slug === 'm2_embroidery' || this.activeMenuElementItem.slug === 'm3_embroidery') {
              this.activeMenuSubComponentIndex = this.activeMenuElementItem.sub_components.length - 1;
              this.activeMenuSubComponentItem = this.activeMenuElementItem.sub_components[this.activeMenuSubComponentIndex];
              this.activeMenuSubComponentItem.style.display = 'flex';
              this.activeMenuElementItem.element.querySelectorAll('.jtbc-embroidery-step').forEach((stepEl, stepIndex) => {
                if (stepIndex !== this.activeMenuSubComponentIndex) {
                  stepEl.style.display = 'none';
                }
              });
            }
          }
        }
        this.wip = false;
        this.updateWidgetData();
        this.initWidgetData();
        this.updateStepButton();
        this.updateProgressBar();
        this.resizeContainer();
        this.scrollToBlock();
      });
    }
    scrollToBlock() {
      let _this = this;
      _this.widgetDataPanel.closest('.product.show-monogram').scrollIntoView({ behavior: 'instant' });
    }
    bindObserver() {
      let _this = this;
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (
            _this.wip ||
            mutation.attributeName === 'data-step' ||
            mutation.target.classList.contains('jtbc-step-button-item') ||
            mutation.target.classList.contains('jtbc-step-button') ||
            mutation.target.classList.contains('jtbc-actions') ||
            mutation.target.classList.contains('jtbc-back-button-item') ||
            mutation.target.classList.contains('jtbc-back-button') ||
            mutation.target.classList.contains('jtbc-progress-bar') ||
            mutation.target.classList.contains('jtbc-embroidery-color__label') ||
            mutation.target.classList.contains('jtbc-product-title')
          ) {
            return;
          }
          // console.log('Mutation observed:', mutation.target.classList);
          // console.log('Mutation type:', mutation.type);
          // console.log('Mutation details:', mutation.attributeName);
          _this.updateWidgetData();
          _this.initWidgetData();
          _this.updateStepButton();
          _this.updateProgressBar();
          _this.resizeContainer();
        });
      });
      const config = { childList: true, subtree: true, attributes: true, characterData: true };
      if (_this.widgetMenuPanel) {
        observer.observe(_this.widgetMenuPanel, config);
      }
    }
    updateStepButton() {
      let _this = this;
      this.backButton.querySelector('button').dataset.step = this.activeStep;
      if (_this.activeStep === 0) {
        _this.stepButton.querySelector('button').innerText = 'SELECT';
        if (_this.activeMenuElementItem.slug === 'm1_embroidery' || _this.activeMenuElementItem.slug === 'm2_embroidery' || _this.activeMenuElementItem.slug === 'm3_embroidery') {
          let inputValid = false;
          if (_this.activeMenuSubComponentItem.querySelector('.jtbc-input-text:not(.jtbc--hidden)')) {
            let inputField = _this.activeMenuSubComponentItem.querySelector('.jtbc-input-text:not(.jtbc--hidden) input');
            inputValid = inputField.value != '' && (new RegExp(inputField.dataset.regexPattern).test(inputField.value) || false);
          }
          if (_this.activeMenuSubComponentItem.querySelector('.jtbc-attribute-item.jtbc--selected')) {
            inputValid = true;
          }
          if (inputValid) {
            _this.stepButton.querySelector('button').disabled = false;
          } else {
            _this.stepButton.querySelector('button').disabled = true;
          }
        } else if (_this.activeMenuElementItem.slug === 'placement') {
          _this.stepButton.querySelector('button').disabled = false;
        }
        _this.stepButton.classList.remove('hide');
        _this.addToCartActions.classList.remove('is-visible');
      } else if (_this.activeStep === _this.totalSteps - 1) {
        _this.stepButton.classList.add('hide');
        _this.addToCartActions.classList.add('is-visible');
      } else {
        _this.addToCartActions.classList.remove('is-visible');
        _this.stepButton.querySelector('button').innerText = 'CONTINUE';
        _this.stepButton.classList.remove('hide');
        if (_this.activeMenuElementItem.slug === 'm1_embroidery' || _this.activeMenuElementItem.slug === 'm2_embroidery' || _this.activeMenuElementItem.slug === 'm3_embroidery') {
          let inputValid = false;
          if (_this.activeMenuSubComponentItem.querySelector('.jtbc-input-text:not(.jtbc--hidden)')) {
            let inputField = _this.activeMenuSubComponentItem.querySelector('.jtbc-input-text:not(.jtbc--hidden) input');
            inputValid = inputField.value != '' && (new RegExp(inputField.dataset.regexPattern).test(inputField.value) || false);
          }
          if (_this.activeMenuSubComponentItem.querySelector('.jtbc-attribute-item.jtbc--selected')) {
            inputValid = true;
          }
          if (inputValid) {
            _this.stepButton.querySelector('button').disabled = false;
          } else {
            _this.stepButton.querySelector('button').disabled = true;
          }
        }
      }
      _this.updateBackButton();
    }
    updateBackButton() {
      let _this = this;
      if (_this.activeStep === 0) {
        _this.backButton.classList.add('hide');
      } else {
        _this.backButton.classList.remove('hide');
      }
    }
    updateWidgetData() {
      let _this = this;
      _this.widgetMenuElements = _this.querySelectorAll('.jtbc-menu-tab-pane.jtbc-menu-tab-pane--active .jtbc-menu-element:not(.jtbc--disabled)');
      _this.widgetMenuElementsData = [];
      _this.widgetMenuElementsSubComponentsCount = 0;
      _this.indexCount = 0;
      _this.totalSteps = 0;
      _this.widgetMenuElements.forEach((el) => {
        let elData = JSON.parse(el.dataset.elementBootstrapData);
        if (elData.slug === 'placement') {
          if (el.querySelector('.jtbc-decision-selector').style.display == 'none') {
            return;
          }
          elData.sub_components = [];
          el.querySelector('.jtbc-menu-element__label').setAttribute('data-step', `${(_this.indexCount + 1 + _this.widgetMenuElementsSubComponentsCount) < 10 ? '0' : ''}${_this.indexCount + 1 + _this.widgetMenuElementsSubComponentsCount}:`);
          _this.indexCount++;
          _this.totalSteps++;
          el.querySelectorAll('.jtbc-radio-button').forEach((subEl) => {
            if (!subEl.querySelector('.jtbc-radio-data')) {
              let dataEleContent = subEl.querySelector('label').textContent.trim();
              let dataEle = document.createElement('div');
              dataEle.classList.add('jtbc-radio-data');
              dataEle.innerText = `${dataEleContent.replace('(+ ', '(+')}`;
              Array.from(subEl.querySelector('label').childNodes).filter((node)=>{return node.nodeType == Node.TEXT_NODE}).forEach((node)=>{node.remove()})
              subEl.querySelector('input').after(dataEle);
            }
          });
        } else if (elData.slug === 'm1_embroidery' || elData.slug === 'm2_embroidery' || elData.slug === 'm3_embroidery') {
          elData.sub_components = el.querySelectorAll('.jtbc-embroidery-step');
          if (!el.querySelector('.jtbc-menu-element__label').classList.contains('hide')) {
            el.querySelector('.jtbc-menu-element__label').classList.add('hide');
          }
          elData.sub_components.forEach((subEl, subIndex) => {
            subEl.setAttribute('data-step', `${(_this.indexCount + 1 + _this.widgetMenuElementsSubComponentsCount + subIndex) < 10 ? '0' : ''}${_this.indexCount + 1 + _this.widgetMenuElementsSubComponentsCount + subIndex}:`);
            if (subEl.dataset.embroideryStep === 'embroidery_color') {
              if (subEl.querySelectorAll('.jtbc-embroidery-color-wrapper:not(.jtbc--hidden)').length > 0) {
                subEl.querySelectorAll('.jtbc-embroidery-color-wrapper:not(.jtbc--hidden) .jtbc-embroidery-color__label').forEach((colorLabel, index) => {
                  let closest_ele = colorLabel.closest('.jtbc-embroidery-color-wrapper');
                  let selected_color = closest_ele.querySelector('.jtbc-attribute-item.jtbc--selected');
                  let selected_color_data = selected_color ? JSON.parse(selected_color.dataset.tooltip) : null;
                  colorLabel.innerText = `Embroidery Color ${(index + 1)}${selected_color_data ? `: ${selected_color_data.title}`: ''}`;
                  colorLabel.classList.add('show');
                  if (index > 0) {
                    colorLabel.style.marginTop = '16px';
                  }
                });
              }
            }
            _this.totalSteps++;
          });
          _this.widgetMenuElementsSubComponentsCount += elData.sub_components.length;
        }
        _this.widgetMenuElementsData.push({...elData, element: el});
      });
    }
    initWidgetData() {
      let _this = this;
      _this.widgetMenuElementsData.forEach((el, index) => {
        if ((_this.activeMenuElementIndex == -1 && index > 0) || (_this.activeMenuElementIndex > -1 && index !== _this.activeMenuElementIndex)) {
          jtbCustomizer.elements[el.slug].hide();
          if (el.slug === 'm1_embroidery' || el.slug === 'm2_embroidery' || el.slug === 'm3_embroidery') {
            el.element.querySelectorAll('.jtbc-embroidery-step').forEach((stepEl) => {
              stepEl.style.display = 'none';
            });
          }
        }
        if ((_this.activeMenuElementIndex == -1 && index === 0 && el.slug === 'placement')) {
          if (el.slug === 'm1_embroidery' || el.slug === 'm2_embroidery' || el.slug === 'm3_embroidery') {
            el.element.querySelectorAll('.jtbc-embroidery-step').forEach((stepEl) => {
              stepEl.style.display = 'none';
            });
          } else if (el.slug === 'placement') {
            el.element.classList.remove('jtbc--hidden');
          }
        }
        if ((index === 0 && _this.activeMenuElementIndex === -1)) {
          if ((index === 0 && _this.activeMenuElementIndex === -1)) {
            _this.activeStep = 0;
          }
          _this.activeMenuElementItem = el;
          if (el.slug === 'm1_embroidery' || el.slug === 'm2_embroidery' || el.slug === 'm3_embroidery') {
            _this.activeMenuSubComponentIndex = 0;
            _this.activeMenuSubComponentItem = el.sub_components[_this.activeMenuSubComponentIndex];
            _this.activeMenuSubComponentItem.style.display = 'flex';
            el.element.querySelectorAll('.jtbc-embroidery-step').forEach((stepEl, stepIndex) => {
              if (stepIndex !== 0) {
                stepEl.style.display = 'none';
              }
            });
          }
        }
      });
      if (_this.activeMenuElementIndex === -1) {
        _this.activeMenuElementIndex = 0;
      }
    }
    updateProgressBar() {
      let progressItems = '';
      for (let i = 0; i < this.totalSteps; i++) {
        progressItems += `
          <div class="jtbc-progress-bar-segment ${i <= this.activeStep ? 'jtbc-progress-bar-segment--active' : ''}"></div>
        `;
      }
      this.widgetProgressBar.innerHTML = `
        ${progressItems}
      `;
    }
  }
  customElements.define('monogram-modal', MonogramModal);
}
